import type {
  DistributionItemView,
  DistributionItemList,
} from "@/api/generated/backendAPI.schemas";

/** 値を隠しているときに出す点の数。値の長さが分からないよう、いつも同じ数にする */
export const MASK = "••••••••••••";

export type DistributionGroup = {
  key: string;
  title: string;
  items: DistributionItemView[];
};

/**
 * 配布物を「あなた用」と「チームごと」に分ける。
 * 返ってくる順（参加者単位 → チーム単位、項目名順）を保つ。
 */
export const groupDistributionItems = (
  items: readonly DistributionItemView[]
): DistributionGroup[] => {
  const groups: DistributionGroup[] = [];
  const find = (key: string, title: string) => {
    let group = groups.find((g) => g.key === key);
    if (!group) {
      group = { key, title, items: [] };
      groups.push(group);
    }
    return group;
  };
  for (const item of items) {
    if (item.scope === "participant") {
      find("participant", "あなた用").items.push(item);
    } else {
      const name = item.teamName ?? "";
      find(`team:${name}`, name ? `チーム「${name}」用` : "チーム用").items.push(item);
    }
  }
  return groups;
};

/** 配布物のカードを出すか。無い開催回・期限切れの開催回では出さない */
export const shouldShowDistributionCard = (
  data: DistributionItemList | undefined
): data is DistributionItemList =>
  Boolean(data && !data.expired && data.items.length > 0);

/** 開始前の案内文 */
export const notStartedMessage = (startDatetime: string): string =>
  `開始日時（${new Date(startDatetime).toLocaleString()}）から表示されます。`;
